import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import ErrorIcon from '@material-ui/icons/ErrorOutline';

import styles from './styles';

function Alert({
    children,
    classes,
    severity,
}) {
    const options = {
        error: {
            icon: ErrorIcon,
            paperClassName: 'paperAlert',
            iconClassName: 'iconAlert',
        },
    }[severity];

    return (
        <Paper
            elevation={0}
            classes={{ root: classNames(classes.paper, classes[options.paperClassName]) }}
        >
            <options.icon className={classNames(classes.icon, classes[options.iconClassName])} />
            {children}
        </Paper>
    );
}

Alert.propTypes = {
    children: PropTypes.node.isRequired,
    classes: PropTypes.object.isRequired,
    severity: PropTypes.oneOf(['error']),
};

Alert.defaultProps = {
    severity: 'error',
};

export { Alert as AlertAlias };
export default withStyles(styles)(Alert);
